import config from "@/config";
import { constants } from "@/constants";
import { Trans } from "react-i18next";

import Logo from "@/components/atoms/Logo";
import OnboardingWizard from "@/components/organisms/onboarding/OnboardingWizard";

const OnBoarding = () => {
  return (
    <div
      className={"flex h-screen flex-1 flex-col items-center justify-center gap-y-10 overflow-hidden py-10 text-center"}
    >
      <div className={"flex items-center gap-1"}>
        <Logo className={"size-6"} /> <div className={"text-2xl font-semibold text-primary"}>{config.APP_NAME}</div>
      </div>
      <OnboardingWizard />
      <p className={"text-xs text-quinary"}>
        <Trans
          i18nKey="needHelp"
          values={{ email: constants.supportMail }}
          components={{ a: <a href={`mailto:${constants.supportMail}`} className={"text-link underline"} /> }}
        />
      </p>
    </div>
  );
};

export default OnBoarding;
